import { useFieldHelper, FieldProps } from 'framework/ui/field';
import Box from '@mui/material/Box';
import { MapedPoliciesDataType } from 'domain/shared/compliance';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';

const PoliciesNameField = ({ expanded }: FieldProps) => {
  const { getValue } = useFieldHelper<MapedPoliciesDataType[]>({ source: 'policies' });
  const policies = getValue();
  const data = expanded ? policies : policies.slice(0, 2);

  return (
    <Box sx={{ pr: 2 }}>
      {data.map(({ policyPath, complianceName, policyType }) => {
        return (
          <Box
            key={policyPath}
            sx={{ position: 'relative', display: 'flex', alignItems: 'center', minHeight: 24 }}
            mb="2px"
          >
            <DownloadFileLinkField
              showNameValue={complianceName || policyType || ''}
              pathValue={policyPath}
              sxButton={{
                minWidth: 0,
                '& .files-list__files-name': { whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left' },
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default PoliciesNameField;
